import { useCallback, useMemo } from "react";
import omit from "lodash/omit";
import { NextRouter, useRouter } from "next/router";

const useQueryParamState = (
  paramName: string,
  routingOptions?: Parameters<NextRouter["push"]>[2]
): [string, (newValue?: string) => void] => {
  const { push, query } = useRouter();
  const otherParams = useMemo(() => omit(query, paramName), [query, paramName]);

  const value = query[paramName];
  const setValue = useCallback(
    (newValue?: string) => {
      push(
        {
          query: {
            ...otherParams,
            ...(newValue
              ? {
                  [`${paramName}`]: encodeURIComponent(newValue),
                }
              : {}),
          },
        },
        undefined,
        routingOptions
      );
    },
    [otherParams, paramName]
  );

  return [value ? decodeURIComponent(String(value)) : "", setValue];
};

export default useQueryParamState;
